import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { motion } from 'framer-motion';
import 'swiper/css';
import 'swiper/css/autoplay';

//MUI
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

//Our Imports
import { imageExist }  from '../../assets/js/init';


export default function AppleCarousel({ offset, nextRef, prevRef, content, showOnce, animate }) {

	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	const [hoveredCard, setHoveredCard] = useState(0);

	const handleInOut = (proFor, proVal) => {
		if (proFor === 'in') {
			setHoveredCard(proVal);
		} else {
			setHoveredCard(0);
		}
	};

	// Parent controls the timing (stagger)
	const containerVariant = {
		hidden: {},
		visible: {
			transition: {
				staggerChildren: 0.2,   // delay between cards
				delayChildren: 0.4
			}
		}
	};

	// Each card animation
	const cardVariant = {
		hidden: {
			opacity: 0,
			y: 80,
			scale: 0.5
		},
		visible: {
			opacity: 1,
			y: 0,
			scale: 1,
			transition: {
				duration: 0.9,
				ease: [0.22, 1, 0.36, 1] // <-- smooth premium easing (important)
			}
		}
	};

	return (
		<div className='carouselOuter'>
			<div className="carouselViewport">

				{/* left mask */}
				<div className="leftMask" style={{ width: offset+25 }} />
				<motion.div
					variants={containerVariant}
					initial='hidden'
					whileInView='visible'
					animate={animate}
					// viewport={{ once: true, margin: '-150px' }}
				>
					<Swiper
						modules={[Navigation, Autoplay]}
						slidesPerView='auto'
						spaceBetween={80}
						loop
						autoplay={ isMobile ? { delay: 2500, disableOnInteraction: false } : false }

						style={{
							paddingLeft: offset + 25, 
							paddingRight: 80   
						}}
						navigation={{
							prevEl: prevRef.current,
							nextEl: nextRef.current
						}}
						onBeforeInit={(swiper) => {
							swiper.params.navigation.prevEl = prevRef.current;
							swiper.params.navigation.nextEl = nextRef.current;
						}}
					>
						{content.map((list, index) => {
							const isHovered = hoveredCard === index + 1;
							const glowColor = list.color;
							return(
								<SwiperSlide key={list.id} className='appleSlide'>
									<motion.div
										variants={cardVariant}
										// whileHover={{ y: -8 }}
										// transition={{ type: 'spring', stiffness: 200, damping: 18 }}
										style={{ height: '100%' }}
									>
										<Box key={index} onMouseEnter={() => handleInOut('in', index + 1)} onMouseLeave={() => handleInOut('out')}>
											<Box
												sx={{
													bgcolor: (isHovered || showOnce) && list.bg,
													transition: 'all 0.6s ease',
													height: '100%',
													borderRadius: 2
												}}
												className={ (isHovered || showOnce) ? 'benefitCards' : 'benefitCard' }
											>
												<Stack justifyContent='space-between' sx={{ height: '100%' }} spacing={1}>
													<Stack spacing={2} sx={{ opacity: 1 }}>
														<Stack direction='row' spacing={1} alignItems='center' sx={{ height: '50px', position: 'relative' }}>
															<Box className='fadeImg'>
																{imageExist({
																	required: '/benefit',
																	url: `/${list.topImg}.svg`,
																	alt: 'all',
																	height: '70px'
																})}
																{/* <img src={list.topImg} width={list.topSize} alt='topImg'/> */}
															</Box>
															<Typography className='font22 fontBold titleSlide'>{list.title}</Typography>
														</Stack>
														<Box sx={{ minHeight: '110px' }}>
															<Typography color='grey' className='font18 fontBold'>{list.description}</Typography>
														</Box>
													</Stack>
													<Stack direction='row' alignItems='flex-end' justifyContent='flex-end'>
														<Box className='fadeBtImg'>
															<img src={list.btImg} width={list.btSize} alt='bottomImg'/>
														</Box>
													</Stack>
												</Stack>
												<Box className='bgDropEffect' sx={{ background: `radial-gradient(circle,rgba(${glowColor}, 0.55) 0%,rgba(${glowColor}, 0.15) 35%,rgba(${glowColor}, 0.05) 55%, transparent 70%)` }}></Box>
											</Box>
										</Box>
									</motion.div>
								</SwiperSlide>
							);
						})}
					</Swiper>
				</motion.div>
			</div>
		</div>
	);
}
